import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { BrandCampaign } from "../../../../shared/models/brandCampaign";
import { BrandCampaignCategory } from "../../../../shared/models/brandCampaignCategory";
import { BrandCampaignPost } from "../../../../shared/models/brandCampaignPost";
import { NotificationService } from "../../../../shared/services/notification.service";
import { BrandCampaignPostService } from "../../shared/services/brand-campaign-post.service";

export interface BrandCampaignCategoryMoveDialogData {
  readonly campaign: BrandCampaign;
  readonly category: BrandCampaignCategory;
  readonly post: BrandCampaignPost;
}

export type BrandCampaignCategoryMoveDialogResult = true | undefined;

@Component({
  selector: "app-brand-campaign-move-post-category-dialog",
  templateUrl: "./brand-campaign-move-post-category-dialog.component.html",
  styleUrls: ["./brand-campaign-move-post-category-dialog.component.scss"],
})
export class BrandCampaignCategoryMoveDialogComponent {
  public moving = false;
  public readonly campaign: BrandCampaign;
  public readonly category: BrandCampaignCategory;
  public readonly categories: BrandCampaignCategory[];
  public readonly post: BrandCampaignPost;
  public selectedCategory: BrandCampaignCategory | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BrandCampaignCategoryMoveDialogData,
    private readonly notificationService: NotificationService,
    private readonly brandCampaignPostService: BrandCampaignPostService,
    private readonly dialogRef: MatDialogRef<
      BrandCampaignCategoryMoveDialogComponent,
      BrandCampaignCategoryMoveDialogResult
    >,
  ) {
    this.campaign = data.campaign;
    this.category = data.category;
    this.post = data.post;
    this.categories = this.campaign.currentDetails.orderedCategories.filter(
      (c: BrandCampaignCategory) => c.id !== this.category.id,
    );
  }

  public selectCategory(category: BrandCampaignCategory): void {
    this.selectedCategory = category;
  }

  public isCategorySelected(category: BrandCampaignCategory): boolean {
    return this.selectedCategory?.id === category.id;
  }

  public move(): void {
    const selectedCategory = this.selectedCategory;
    if (!selectedCategory) {
      return;
    }

    this.moving = true;
    this.brandCampaignPostService
      .updateCampaignPostCategory(
        this.campaign.id,
        this.campaign.currentDetails.id,
        this.post.id,
        this.category.id,
        selectedCategory.id,
      )
      .subscribe({
        next: () => {
          this.campaign.currentDetails.categories.forEach((loopCategory) => {
            if (loopCategory.id === selectedCategory.id) {
              loopCategory.posts.push(this.post);
            } else if (loopCategory.id === this.category.id) {
              loopCategory.posts = loopCategory.posts.filter(
                (loopPost) => loopPost.id !== this.post.id,
              );
            }
          });
          this.notificationService.success(
            "brand.campaign.content.postCategoryMovedSuccess",
          );
          this.dialogRef.close(true);
          this.moving = false;
        },
        error: () => {
          this.moving = false;
          this.notificationService.error(
            "brand.campaign.content.movePostCategory.errorMovingThePostCategory",
          );
        },
      });
  }

  public isMoveButtonDisabled(): boolean {
    return !this.selectedCategory || this.moving;
  }
}
